const ShiftTransaction = {
  display: ({ reference = '' }) => (reference ? !reference.includes('payout') : true)
};

export default ShiftTransaction;
